// extracted by mini-css-extract-plugin
module.exports = {"icon":"TooltipIcon_icon__4vRZc","tooltip":"TooltipIcon_tooltip__4R6Qa"};